export * from './golden-duel-modal-container';